import React from "react";
import SummaryHeader from "components/header/SummaryHeader";
import { ShoppingBag } from "lucide-react";
import PurchaseOrderTable from "./components/PurchaseOrderTable";

const PurchaseOrder = () => {
	return (
	    <div className="space-y-6">
			<SummaryHeader
				title="Purchase Orders"
				icon={ShoppingBag}
				description="View purchased items"
				color={"violet"}
			/>
			<PurchaseOrderTable recordId="0" mode="edit"/>
	    </div>
    );
};

export default (PurchaseOrder);
